import { useHistory, useLocation } from 'react-router-dom';
import { LocationStateType } from 'v2/models';

export default function useHistoryBackState(defaultPath = '/') {
  const history = useHistory();
  const counterToGoBackFromState =
    useLocation<LocationStateType>().state?.counterToGoBack;
  const counterToGoBack = counterToGoBackFromState || -1;
  const backLinkTitle =
    useLocation<LocationStateType>().state?.backLinkTitle || '';

  const goBackHistory = () => {
    if (backLinkTitle) {
      history.go(counterToGoBack);
    } else {
      history.push(defaultPath);
    }
  };

  return { backLinkTitle, counterToGoBack, goBackHistory };
}
